import { CvpSettings } from "../api/settings/CvpSettings";

export enum PostMessageTypes {
  CVPEmbedReadyForSettings = "CVPEmbedReadyForSettings",
  CVPEmbedConfig = "CVPEmbedConfig",
  CVPEmbedHasMounted = "CVPEmbedHasMounted",
  CVPResizeIframe = "CVPResizeIframe",
  CVPReload = "CVPReload",
  CVPRedirectHost = "CVPRedirectHost",
  CVPScrollHost = "CVPScrollHost",
}

export interface PostMessageCVPScrollHost {
  type: PostMessageTypes.CVPScrollHost;
  top: number;
  height: number;
}

export interface PostMessageCVPRedirectHost {
  type: PostMessageTypes.CVPRedirectHost;
  url: string;
  method: "push" | "replace";
  goBackIfPreviousUrlIsTheSame: boolean;
}

export interface PostMessageCVPEmbedReadyForSettings {
  type: PostMessageTypes.CVPEmbedReadyForSettings;
  loadId: string;
}

export interface PostMessageCVPEmbedConfig {
  type: PostMessageTypes.CVPEmbedConfig;
  settings: CvpSettings;
  sandbox?: boolean;
  hostUrl?: string;
}

export interface PostMessageCVPEmbedHasMounted {
  type: PostMessageTypes.CVPEmbedHasMounted;
}

export interface PostMessageCVPResizeIframe {
  type: PostMessageTypes.CVPResizeIframe;
  idEmbed: string;
}

export interface PostMessageCVPReload {
  type: PostMessageTypes.CVPReload;
}
